import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const DebtManagementAssumptions = [
  {
    key: 'AdditionalSavingsPerMonth',
    title: 'Additional Savings Per Month',
    template: value => `${formatAsCurrency(value)} per month`,
  },
  {
    title: 'Loan Payoff Strategy',
    key: 'LoanPayoffStrategy',
    template: value => value,
  },
];

export default DebtManagementAssumptions;
